import React, { useEffect, useRef } from 'react';

import {
  ContentLayout,
  ErrorPageContent,
} from '@silvertours/common-landingpages-view';
import { StageLegacy, ErrorPage } from '@silvertours/front-features';
import { analytics } from '@silvertours/front-entities';

import { Body } from './body';

const ErrorContent = ({
  content: {
    statusCode,
    stage,
    textContent: { primaryHeadline },
  },
  ...commonProps
}: ContentLayout<ErrorPageContent>) => {
  const tracked = useRef(false);
  useEffect(() => {
    if (!tracked.current) {
      const label = statusCode?.toString() ?? '';
      analytics.gtm.trackErrorPageView(label);
      tracked.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Body
      title={primaryHeadline}
      stage={
        <StageLegacy.Stage
          content={stage.content}
          headline={primaryHeadline}
          isErrorPage
        />
      }
      statusCode={statusCode}
      isErrorPage
      content={({ containerModule }) => [
        containerModule('errorpage.contact', <ErrorPage.Contact />),
      ]}
      {...commonProps}
    />
  );
};

export { ErrorContent };
